export const COUNT_REFRESH_PAGE_KEY = 'count_refresh_page';
export const AUTH_TOKEN_EXPIRY_TIME = 'auth_token_expiry_time';
export const REFRESH_TOKEN = 'refresh_token';
// Обфусцированный ключ для хранения данных аутентификации
// Имитирует ключ настройки локали приложения
export const LAST_ACCESS_TOKEN_KEY = 'app_locale_pref';
